// extracted by mini-css-extract-plugin
module.exports = {"resultGridImg":"result_resultGridImg__7av9f"};